import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { SEO as SEO_CONTENT } from "@/content";

const AboutPage = () => (
  <>
    <SEO title={SEO_CONTENT.about.title} description={SEO_CONTENT.about.description} />

    <section data-testid="about-hero" className="border-b border-stone/60 relative overflow-hidden grain">
      <div
        aria-hidden="true"
        className="absolute -bottom-32 -right-24 w-[40vw] max-w-[480px] aspect-square rounded-full bg-[radial-gradient(circle,rgba(36,95,90,0.10),transparent_65%)] blur-3xl"
      />
      <div className="relative mx-auto max-w-3xl px-6 md:px-10 pt-40 md:pt-52 pb-24 md:pb-32">
        <Reveal>
          <p className="eyebrow mb-6">About</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.08]" data-testid="about-title">
            Tara Aurora
          </h1>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-10 text-lg md:text-xl leading-relaxed text-charcoal/90 font-serif">
            Tara Aurora writes about the places where neuroscience,
            nervous-system regulation, somatic awareness and the deeper wisdom
            of the body meet.
          </p>
          <p className="mt-7 text-base md:text-lg leading-relaxed text-taupe">
            Her work invites readers away from constantly trying to fix
            themselves and toward understanding the intelligent ways the body
            learned to protect them.
          </p>
        </Reveal>
      </div>
    </section>

    <section data-testid="about-philosophy" className="bg-white/50 border-b border-stone/60">
      <div className="mx-auto max-w-3xl px-6 md:px-10 py-24 md:py-36">
        <Reveal>
          <h2 className="font-serif text-3xl md:text-4xl tracking-tight mb-12">
            A quiet philosophy.
          </h2>
        </Reveal>
        <div className="space-y-8">
          {[
            "Healing isn’t about fixing yourself. It’s about understanding what your system learned to do to keep you safe.",
            "Your body isn’t working against you. It’s trying to protect you.",
            "You were never meant to live in survival mode.",
          ].map((line, i) => (
            <Reveal key={line} delay={0.1 * i} y={16}>
              <p className="font-serif italic text-2xl md:text-3xl leading-snug text-charcoal/90 border-l-2 border-teal/50 pl-8">
                {line}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section data-testid="about-cta" className="bg-cream/70">
      <div className="mx-auto max-w-3xl px-6 md:px-10 py-24 md:py-32 text-center">
        <Reveal>
          <h2 className="font-serif text-3xl md:text-4xl tracking-tight">
            Begin where you are.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/regulate"
              data-testid="about-explore-regulate-button"
              className="bg-teal text-ivory text-xs uppercase tracking-[0.25em] px-10 py-4 hover:bg-deepteal transition-colors duration-500"
            >
              Explore REGULATE
            </Link>
            <Link
              to="/begin-here"
              data-testid="about-begin-here-button"
              className="border border-stone bg-white/50 text-charcoal text-xs uppercase tracking-[0.25em] px-10 py-4 hover:border-teal hover:text-deepteal transition-colors duration-500"
            >
              Begin Here
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default AboutPage;
